const delayDefault = 100;
const invervalTimeout = 10;

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.intervalCount = 0;
    this.delay = delayDefault;

    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    if (!this.classList.contains('no-hover')) {
      this.mainDetailsToggle.addEventListener('mouseenter', e => {
        this.interval = setInterval(() => {
          if (this.intervalCount == this.delay) {
            e.target.open = true;
          }
  
          this.delay = delayDefault;
          this.intervalCount += invervalTimeout;
        }, invervalTimeout);
      });
  
      this.mainDetailsToggle.addEventListener('mouseleave', e => {
        clearInterval(this.interval);
  
        this.intervalCount = 0;
        e.target.open = false;
  
        let hoveringHeaderMenu = document.querySelector('header-menu:hover');
        
        if (hoveringHeaderMenu) {
          hoveringHeaderMenu.delay = 0;
        }
      });
    }

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut(event) {
    if(!event.target.classList.contains('slider-button')) {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    super.onToggle();
    
    if (!this.header) return;

    document.documentElement.classList.toggle('overflow-hidden', this.mainDetailsToggle.open);

    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

class FakeSelect extends DetailsDisclosure {
  constructor() {
    super();
  }
}

customElements.define('fake-select', FakeSelect);